import React, {useEffect, useState} from 'react';
import {connect, setStore} from "trim-redux";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";
import {InputAdornment, useMediaQuery} from "@mui/material";
import RayaField from "../elements/fields/RayaField";
import {MapPin} from "lucide-react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import {theme} from "../../../config/design/theme";
import Button from "@mui/material/Button";
import LoginDialog from "../../pages/front/components/LoginDialog";
import AddressChooserDialog from "./AddressChooserDialog";
import {truncate} from "../../../config/values";


const AddressChooserBtn = (props) => {
    const { t } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [authOpen, setAuthOpen] = useState(false);
    const [open, setOpen] = useState(false);
    const [alert, setAlert] = useState(false);

    const handleClickBtn = () => {
        if(props.isAuth){
            setOpen(true);
            setAlert(false);
        }else{
            setAuthOpen(true);
        }
    }

    useEffect(() => {
        if (!!props.address_dialog) {
            setOpen(true);
            setAlert(true);

            setStore({
                address_dialog:false
            })
        }
    }, [props.address_dialog]);
    return (
        <>
            <Button
                className={clsx("pink-field-btn",props.clName)}
                startIcon={<MapPin className="lucide-icon-primary"/>}
                onClick={() => handleClickBtn()}
            >
                {
                    !!props.user?.address ?
                        truncate(!!props.user.address.label ? props.user.address.label +", "+props.user.address.manual_address : props.user.address.manual_address,isMobile ? 12 : 25)
                    :
                        t(isMobile ? 'selectAddress'  : 'selectYourAddress')
                }
            </Button>
            <LoginDialog open={authOpen} setOpen={setAuthOpen} />
            {
                !!props.isAuth &&
                <AddressChooserDialog open={open} setOpen={setOpen} has_alert={alert}/>
            }

        </>
    );
};
const mstp = state => ({
    navCollapsed: state.navCollapsed,
    logo: state.logo,
    user: state.user,
    isAuth: state.isAuth,
    address_dialog:state.address_dialog
});
export default withStyles(Styles)(connect(mstp)(AddressChooserBtn));
